export function checkBrandIsGenderSensitive(context) {
    return $(context).find('.gender-switch')
        .toArray()
        .some((el) => $(el).find('input').is(':checked'));
}
